import React from 'react';
import PropTypes from 'prop-types';
import { COLOR_BLUE } from 'config/colors';

export default function CaretDown({ fill = COLOR_BLUE }) {
	return (
		<svg
			className="svg caret-down"
			width="12"
			height="6"
			viewBox="0 0 12 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 6L12 0H0L6 6Z"
				fill={fill}
			/>
		</svg>
	);
}

CaretDown.propTypes = {
	fill: PropTypes.string,
};
